<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :title="id?'编辑部门':'添加部门'"
        :close-on-press-escape="false"
        width="550px"
        append-to-body
        :before-close="handleClose">
        <el-form ref="form" :rules="rules" :model="formItem" label-width="120px" class="pr20">
            <el-form-item label="部门名称：" prop="name" class="label-required">
                <el-input v-model.trim="formItem.name" ref="nameInput" clearable show-word-limit maxlength="15" class="word-limit-input" placeholder="请输入部门名称，最多15个字"></el-input>
            </el-form-item>
            <el-form-item label="上级部门：" prop="p_group_id" class="label-required">
                <TreeSelect
                    :options="departmentData"
                    v-model="formItem.p_group_id"
                    :normalizer="normalizer"
                    :defaultExpandLevel="3"
                    @open="treeOpen"
                    placeholder="请选择"
                    noResultsText="暂无数据"
                    noOptionsText="暂无可用数据"
                    class="font12px"
                />
            </el-form-item>
            <el-form-item label="部门负责人：">
                <ESelect
                    ref="leaderSelect"
                    v-model="formItem.leader_id"
                    filterable
                    remote
                    clearable
                    :remote-method="getUserList"
                    :loading="leaderLoading"
                    class="full-w"
                    placeholder="请输入成员名称关键字搜索成员">
                    <el-option
                        v-for="item in userList"
                        :key="item.id"
                        :label="item.name"
                        :disabled="item.disabled"
                        :value="item.id">
                    </el-option>
                </ESelect>
            </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn ml20">保存
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
    import API from '@/api/department.js';

    import TreeSelect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'

    export default {
        name: "DepartmentModal",
        components: {
            TreeSelect,
        },
        props: {
            id: [Number, String],
        },
        data() {
            let validateEmoji = (rule, value, callback)=>{
                let reg = /(\ud83c[\udc00-\udfff])|(\ud83d[\udc00-\udfff])|(\ud83e[\udc00-\udfff])|[\u2100-\u32ff]|[\u0030-\u007f][\u20d0-\u20ff]|[\u0080-\u00ff]/g;
                if(reg.test(value)){
                    callback(new Error('不可输入表情'));
                }else{
                    callback();
                }
            };
            return {
                submitLoading: false,
                leaderLoading: false,
                dialogVisible: false,
                formItem: {
                    name: '',
                    leader_id: '',
                    p_group_id: null,
                },
                rules: {
                    name: [
                        {required: true, message: '请输入部门名称', trigger: 'blur'},
                        {max: 15, message: '最多15个字', trigger: 'blur'},
                        { validator: validateEmoji, trigger: 'blur' },
                    ],
                    p_group_id: [
                        {required: true, message: '请选择上级部门', trigger: 'blur'},
                    ]
                },
                userList: [],
                departmentData: [],
                normalizer(node) {
                    return {
                        id: node.id,
                        label: node.name,
                        children: node.children,
                        isDisabled:node.disable,
                    }
                },
            }
        },
        created() {

        },
        mounted() {

        },
        computed: {},
        methods: {
            handleClose() {
                this.dialogVisible = false;
                this.resetForm();
            },
            showModal() {
                this.getDepartmentTree();
                this.dialogVisible = true;
                this.$nextTick(() => {
                    if (this.id) {
                        this.getDepartmentInfo();
                    }
                    this.$refs.nameInput.focus();
                })
            },
            resetForm() {
                this.submitLoading = false;
                this.userList = [];
                this.formItem.leader_id = '';
                this.$refs['form'].resetFields();
            },
            getDepartmentTree() {
                API.getTree().then(res => {
                    this.departmentData = [res.data];
                }, (err) => {
                    console.log('getDepartmentTree error', err);
                    this.departmentData = [];
                });
            },
            getDepartmentInfo() {
                API.getInfo({
                    id: this.id,
                }).then(res => {
                    let resData = res.data||{};
                    this.formItem.name = resData.name;
                    this.formItem.p_group_id = resData.pid||resData.p_group_id;
                    this.formItem.leader_id = resData.leader_id||'';
                    if(resData.leader_id&&resData.leader_name){
                        this.userList = [{
                            id:resData.leader_id,
                            name:resData.leader_name,
                        }]
                    }
                }, (err) => {
                    console.log('getInfo error', err);

                });
            },
            handleSubmit() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.submitLoading = true;
                        if(this.id){
                            API.editGroup({
                                id:this.id,
                                name:this.formItem.name,
                                p_group_id:this.formItem.p_group_id,
                                leader_id:this.formItem.leader_id,
                            }).then(res => {
                                this.$message.success(res.info || '操作成功');
                                this.dialogVisible = false;
                                this.resetForm();
                                this.$emit('update');
                            }, (err) => {
                                console.log('addRole error', err);
                                this.$message.error(err.info || '操作失败');
                                this.submitLoading = false;
                            });
                        }else{
                            API.addGroup(this.formItem).then(res => {
                                this.$messageBox.confirm('保存成功，是否继续添加？', '提示', {
                                    closeOnPressEscape:false,
                                    confirmButtonText: '继续添加',
                                    cancelButtonText: '否',
                                    type: 'success'
                                }).then(() => {
                                    this.getDepartmentTree();
                                    this.resetForm();
                                    this.$emit('update');
                                }).catch(() => {
                                    this.dialogVisible = false;
                                    this.resetForm();
                                    this.$emit('update');
                                });
                                this.submitLoading = false;

                            }, (err) => {
                                console.log('addRole error', err);
                                this.$message.error(err.info || '操作失败');
                                this.submitLoading = false;
                            });
                        }
                    } else {
                        return false;
                    }
                });
            },
            getUserList(query) {
                if (query !== '') {
                    this.leaderLoading = true;
                    API.getUserList({
                        search: query,
                    }).then(res => {
                        this.userList = res.data || [];
                        this.leaderLoading = false;
                    }, (err) => {
                        console.log('getUserList error', err);
                        this.userList = [];
                        this.leaderLoading = false;
                    });
                } else {
                    this.userList = [];
                }
            },
            treeOpen(){
                this.$refs.leaderSelect.blur();
            }
        },
    }
</script>

<style lang="scss" scoped>
    .action-btn {
        width: 120px;
    }

    .my-tree-wrap {
        min-height: 100px;
        max-height: 250px;
        overflow: auto;
        padding-left: 20px;
        padding-right: 30px;
    }

    ::v-deep .word-limit-input input{
        padding-right: 44px;
    }
</style>
